<template>
  <div
    class="nav-container"
    :style="{
      width: isNavCollapsed ? '0px' : '150px',
      overflow: 'hidden',
      transition: 'width 0.3s ease',
      flexShrink: 0,
    }"
  >
    <!-- <router-link to="/" class="logo">
      <img class="thumb" src="../../assets/icon_home@2x.png" alt="logo">
      <span class="parent-name">{{ routerParent }}</span>
    </router-link> -->
    <div class="logo">
      <img
        class="thumb"
        src="../../assets/icon_home@2x.png"
        alt="logo"
        @click="hideNav"
      />
      <span class="parent-name">{{ routerParent }}</span>
    </div>
    <aside class="app-aside">
      <nav role="main" class="main-nav">
        <el-menu
          unique-opened
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          background-color="#212625"
          text-color="#ffffff"
          active-text-color="#ffffff"
          router
        >
          <template v-for="(item, index) in routes">
            <!-- 只显示带有 alias 别名配置的路由 (我们的一级菜单项) -->
            <template v-if="item.meta && item.meta.alias">
              <!-- 包含子菜单的情况 -->
              <el-submenu
                v-if="
                  item.children &&
                  item.children.length > 0 &&
                  (!item.meta || !item.meta.hideSubmenu)
                "
                :index="item.name"
                :key="`sub-${index}`"
              >
                <template slot="title">
                  <i :class="'icon icon-' + item.meta.alias"></i>
                  <span>{{ item.name }}</span>
                </template>

                <el-menu-item
                  v-for="(subItem, subIndex) in item.children"
                  v-if="!subItem.meta || !subItem.meta.hidden"
                  :key="`sub-item-${index}-${subIndex}`"
                  :index="subItem.path"
                >
                  {{ subItem.nameDisplay }}
                </el-menu-item>
              </el-submenu>

              <!-- 没有子菜单的情况 -->
              <el-menu-item v-else :index="item.path" :key="`item-${index}`">
                <i :class="'icon icon-' + item.meta.alias"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </nav>
    </aside>
  </div>
</template>

<script>
export default {
  props: {
    isNavCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      routes: [],
      routerParent: "", // 存储当前的一级栏目名称
    };
  },
  computed: {
    activeMenu() {
      const { path } = this.$route;

      // 1. 提取侧边栏中所有能被高亮显示的合法路径（也就是所有的 <el-menu-item> 的 index）
      const validMenuPaths = [];
      this.routes.forEach((route) => {
        if (route.meta && route.meta.alias) {
          if (
            route.children &&
            route.children.length > 0 &&
            (!route.meta || !route.meta.hideSubmenu)
          ) {
            route.children.forEach((sub) => {
              // 仅保留非隐藏的菜单路径，隐藏页（如发布、编辑等）应由下方父级逻辑高亮
              if (sub.path && (!sub.meta || !sub.meta.hidden)) {
                validMenuPaths.push(sub.path);
              }
            });
          } else {
            if (route.path) validMenuPaths.push(route.path);
          }
        }
      });

      // 2. 如果当前路由正好在合法菜单里，直接高亮
      if (validMenuPaths.includes(path)) {
        return path;
      }

      // 3. 通用处理逻辑：如果当前路由属于某个子页面（比如 /agent/company/add）
      // 循环切掉路径的最后一段，然后去找对应的父级。
      let pathParts = path.split("/");

      // 注意：至少保留 /xxx/yyy 的层级再去尝试匹配
      while (pathParts.length > 2) {
        pathParts.pop(); // 切掉最后一层，比如 /agent/company/add 变成 /agent/company
        const testPathPrefix = pathParts.join("/");

        // 在所有有效菜单中，寻找哪一个路径是以这个前缀开头的 (例如 /agent/company/list 会匹配上)
        const matchedParent = validMenuPaths.find(
          (p) => p.startsWith(testPathPrefix + "/") || p === testPathPrefix,
        );
        if (matchedParent) {
          return matchedParent; // 找到了最近的归属父级，高亮它
        }
      }

      // 4. 彻底找不到时的保底
      return path;
    },
  },
  methods: {
    updateRouterParent() {
      // 获取当前路由的 meta.parent
      this.routerParent =
        this.$route.meta && this.$route.meta.parent
          ? this.$route.meta.parent
          : "";
    },
    hideNav() {
      this.$emit("collapse");
      const header = document.querySelector(".page-header");
      if (header) {
        header.style.height = "25px";
      }
      const main = document.querySelector(".page-main");
      if (main) {
        main.style.paddingLeft = "0";
      }
    },
  },

  created() {
    // 优先从 localStorage 获取权限过滤后的路由，否则取默认全量路由
    this.routes = localStorage.getItem("routes")
      ? JSON.parse(localStorage.getItem("routes"))
      : this.$router.options.routes;
    // 初始执行一次
    this.updateRouterParent();
  },
  watch: {
    $route: function () {
      // 路由变化时可以重新获取 routes 以防权限在中途变更
      this.routes = localStorage.getItem("routes")
        ? JSON.parse(localStorage.getItem("routes"))
        : this.$router.options.routes;
      // 更新顶部显示的菜单名称
      this.updateRouterParent();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/common/styles/base/mixin-common";
$mainNavWidth: 150px;
$zIndex: 100;

.nav-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 4;

  .logo {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    text-decoration: none; // 防止文字有下划线
    color: #333; // 文字颜色
    height: 80px;

    .thumb {
      width: 70px;
      height: 70px;
      cursor: pointer;
    }

    .parent-name {
      width: 70px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .app-aside {
    width: $mainNavWidth;
    background-color: #212625;
    overflow-y: overlay;
    overflow-x: hidden;
    flex: 1;

    &::-webkit-scrollbar {
      width: 4px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    .main-nav {
      width: 150px;

      /* 覆盖 Element UI 的默认菜单样式 */
      .el-menu-vertical-demo {
        width: 150px;
        border-right: none; // 移除默认的右侧边框

        // ::v-deep .is-active {
        //   >.el-submenu__title {
        //     span {
        //       color: #4d6cea !important;
        //     }
        //   }
        // }

        .el-submenu__title {
          &:hover {
            background-color: #2b2b36 !important; // 鼠标悬停时的稍亮暗色
          }
        }

        .el-menu-item {
          &:hover {
            background-color: #2b2b36 !important;
          }

          &.is-active {
            background: linear-gradient(90deg, #4a63e8 0%, #5b98f5 100%);
            box-shadow: 0rpx 1rpx 1rpx 0rpx rgba(0, 0, 0, 0.06);
            border-radius: 3rpx;
            color: #ffffff !important;
            margin: 4px 8px;
            height: 40px;
            line-height: 40px;
          }
        }

        /* 未激活时的子菜单项样式 */
        .el-submenu .el-menu-item {
          min-width: unset;
          padding-left: 50px !important;
          height: 40px;
          line-height: 40px;
          margin: 4px 8px;
          border-radius: 4px;

          &.is-active {
            padding-left: 42px !important; // 由于增加了 margin，相应减少 padding 以保持对齐
          }
        }

        .icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          vertical-align: middle;
          @include backgroundImage(
            "../../assets/icon_menu_32@2x.png",
            no-repeat,
            center,
            center,
            40px,
            // 为了适应 el-menu 的流式布局调整大小
            auto
          );

          /* 图标位置 (从原来的 64px 缩小到 40px) */
          &.icon-shop {
            background-position: 0 0;
          }

          &.icon-service {
            background-position: 0 -20px;
          }

          &.icon-order {
            background-position: 0 -45px;
          }

          &.icon-goods {
            background-position: 0 -72px;
          }

          &.icon-user {
            background-position: 0 -95px;
          }

          &.icon-distribution {
            background-position: 0 -120px;
          }

          &.icon-caiwu {
            background-position: 0 -145px;
          }

          &.icon-marketing {
            background-position: 0 -140px;
          }

          &.icon-permission {
            background-position: 0 -194px;
          }

          &.icon-s-marketing {
            background-position: 0 -168px;
          }

          &.icon-performance {
            background-position: 0 -252px;
          }
        }

        ::v-deep .el-submenu__icon-arrow {
          color: #ffffff !important;
        }

        /* 当菜单项或其父级子菜单激活时，使用激活状态的图标 */
        .is-active > .el-submenu__title .icon,
        .is-active .icon {
          &.icon-shop {
            background-position: 0 0;
          }

          &.icon-service {
            background-position: 0 -20px;
          }

          &.icon-order {
            background-position: 0 -45px;
          }

          &.icon-goods {
            background-position: 0 -72px;
          }

          &.icon-user {
            background-position: 0 -95px;
          }

          &.icon-distribution {
            background-position: 0 -120px;
          }

          &.icon-caiwu {
            background-position: 0 -145px;
          }

          &.icon-marketing {
            background-position: 0 -140px;
          }

          &.icon-permission {
            background-position: 0 -194px;
          }

          &.icon-s-marketing {
            background-position: 0 -168px;
          }

          &.icon-performance {
            background-position: 0 -252px;
          }
        }
      }
    }
  }
}
</style>
